import React, { useState, useEffect } from 'react';
import { User } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { getClientCredits } from '../lib/callables';
import './Navigation.css';

type NavigationProps = {
  user: User;
};

export default function Navigation({ user }: NavigationProps) {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const [balance, setBalance] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchCredits = async (showLoading: boolean) => {
      try {
        if (showLoading) setLoading(true);
        const data = await getClientCredits();
        if (cancelled) return;
        setBalance(data.creditBalance || 0);
      } catch (error) {
        console.error('Failed to load credit balance:', error);
        if (!cancelled) setBalance(0);
      } finally {
        if (!cancelled && showLoading) setLoading(false);
      }
    };

    fetchCredits(true);

    // Marketplace and Billing hold their own balance state, so they broadcast
    // when a purchase changes it. Refetch quietly — no loading flicker.
    const onChanged = () => { fetchCredits(false); };
    window.addEventListener('pixano:credits-changed', onChanged);

    return () => {
      cancelled = true;
      window.removeEventListener('pixano:credits-changed', onChanged);
    };
  }, []);

  return (
    <nav className="main-nav" style={{ background: colors.card, borderBottomColor: colors.border }}>
      <div className="nav-container">
          <div className="nav-right" style={{ marginLeft: 'auto' }}>
            <div className="nav-user">
              <span className="nav-user__label">Signed in</span>
              <strong className="nav-user__value">{user.email || user.uid}</strong>
            </div>

            <div className="nav-balance" style={{ borderColor: colors.border }}>
              <div className="nav-balance__label">Credits Balance</div>
              <div className="nav-balance__value" style={{ color: colors.primary }}>
                {loading ? '—' : balance.toLocaleString()}
              </div>
            </div>

            <button
              className="nav-topup-btn"
              style={{ background: colors.primary }}
              onClick={() => navigate('/billing')}
            >
              Buy Credits
            </button>
          </div>
        </div>
      </nav>
  );
}

